import {
  GlobalFilterRoute,
  GlobalFilterPathName,
} from '@/modules/ta/globalfilters/globalfilters.constants';
import { GlobalFilterRouteConfig } from '@/modules/ta/globalfilters/GlobalFilterRouteConfig';

export const router = GlobalFilterRouteConfig.factory([
  {
    path: `/${GlobalFilterRoute.FILTERS}`,
    name: GlobalFilterPathName.FILTERS,
    component: () =>
      import(/* webpackChunkName: "globalfilters-page" */ './pages/GlobalFiltersPage.vue'),
  },
]);
